import React from 'react';
import { Sun, Moon, Sunset, Sparkles } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import { motion, AnimatePresence } from 'framer-motion';

export default function ThemeToggle() {
    const { currentTheme, setTheme } = useTheme();

    const toggleTheme = () => {
        const newTheme = currentTheme === 'morning' ? 'night' : 'morning';
        setTheme(newTheme, false); // Turn off auto mode when manually toggling
    };

    return (
        <button
            onClick={toggleTheme}
            className="p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors relative"
            aria-label="Toggle theme"
            title={currentTheme === 'morning' ? 'Switch to Dark Mode' : 'Switch to Light Mode'}
        >
            <AnimatePresence mode="wait">
                {currentTheme === 'morning' ? (
                    <motion.div
                        key="sun"
                        initial={{ opacity: 0, rotate: -90 }}
                        animate={{ opacity: 1, rotate: 0 }}
                        exit={{ opacity: 0, rotate: 90 }}
                        transition={{ duration: 0.2 }}
                    >
                        <Sun className="w-5 h-5 text-amber-500" />
                    </motion.div>
                ) : (
                    <motion.div
                        key="moon"
                        initial={{ opacity: 0, rotate: 90 }}
                        animate={{ opacity: 1, rotate: 0 }}
                        exit={{ opacity: 0, rotate: -90 }}
                        transition={{ duration: 0.2 }}
                    >
                        <Moon className="w-5 h-5 text-indigo-400" />
                    </motion.div>
                )}
            </AnimatePresence>
        </button>
    );
}
